import { render, staticRenderFns } from "./FlagUserForm.vue?vue&type=template&id=3a25aef8&scoped=true"
import script from "./FlagUserForm.vue?vue&type=script&lang=ts"
export * from "./FlagUserForm.vue?vue&type=script&lang=ts"
import style0 from "./FlagUserForm.vue?vue&type=style&index=0&id=3a25aef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a25aef8",
  null
  
)

export default component.exports